<template>
  <b-row>
    <b-col cols="6" class="pr-0">
      <b-row>
        <b-col cols="12" class="row">
          <b-col cols="3" class="text-subtitle">
            <label>Keluhan<span class="text-danger" v-if="this.checkValueData(this.trx) && this.trx.kategori_id == 2">*</span></label>
          </b-col>
          <b-col cols="9" class="float-right pen-isMobile">
            <div class="row d-flex justify-content-end mr-2">
              <div class="mt-2">
                <span @click="penColorKeluhan('blue');isColorActiveKeluhan = 'blue'" class="dot grow" style="background-color: blue;"
                  :class="{ color_active: isColorActiveKeluhan === 'blue' }"></span>
                <span @click="penColorKeluhan('red');isColorActiveKeluhan = 'red'" class="dot grow" style="background-color: red;"
                  :class="{ color_active: isColorActiveKeluhan === 'red' }"></span>
                <span @click="penColorKeluhan('#54c756');isColorActiveKeluhan = 'green'" class="dot grow"
                  style="background-color: #54c756;" :class="{ color_active: isColorActiveKeluhan === 'green' }"></span>
                <span @click="penColorKeluhan('#555');isColorActiveKeluhan = 'black'" class="dot grow" style="background-color: #555;"
                  :class="{ color_active: isColorActiveKeluhan === 'black' }"></span>
                <span @click="penColorKeluhan('orange');isColorActiveKeluhan = 'yellow'" class="dot grow"
                  style="background-color: orange;" :class="{ color_active: isColorActiveKeluhan === 'yellow' }"></span>
              </div>
              <font-awesome-icon
                icon="eraser"
                class="font-size-xl m-2 grow icon"
                v-on:click="setDrawPostDataKeluhan('eraser');"
                v-show="!isHiddenKeluhan"
                :class="{ active_tool: isActiveKeluhan === 'eraser' }" />
              <font-awesome-icon
                icon="pen-alt"
                class="font-size-xl m-2 grow icon"
                v-on:click="setDrawPostDataKeluhan('pen');"
                :class="{ active_tool: isActiveKeluhan === 'pen' }" />
              <font-awesome-icon
                icon="keyboard"
                class="font-size-xl m-2 grow icon"
                v-on:click="setDrawPostDataKeluhan('keyboard');"
                  :class="{ active_tool: isActiveKeluhan === 'keyboard' }" />
            </div>
            <div class="row d-flex justify-content-end mr-2">
              <input type="range" class="custom-range pen-width" min="1" max="50" v-model.number="penWidthKeluhan" />
            </div>
          </b-col>
        </b-col>
        <b-col cols="12" id="keluhan_canvas" v-show="!isHiddenKeluhan">
          <canvas
            id="keluhan-canvas"
            ref="canvaskeluhan"
            @mousedown="handleMousedownKeluhan"
            @mouseup="handleMouseupKeluhan"
            @mousemove="handleMousemoveKeluhan"
            @touchstart="handleTouchstartKeluhan"
            @touchend="handleTouchendKeluhan"
            @touchmove="handleTouchmoveKeluhan"
            :width="canvasWidth"
            :height="canvasHeight"
          >
            Your browser does not support the HTML 5 Canvas.
          </canvas>
        </b-col>
        <b-col cols="2" v-show="!isHiddenKeluhan">
          <b-button @click="clearKeluhan" variant="warning" size="sm" class="m-1">Clear</b-button>
        </b-col>

        <b-col cols="12" id="editor_keluhan" v-show="isHiddenKeluhan">
          <Editor
            :height="contentHeight"
            :width="contentWidth"
            class="form-keluhan"
            :editorContent="keluhan.value"
            v-on:update-content="updateContentKeluhan"
          />
          <b-form-invalid-feedback
            style="text-transform: none"
            :state="renderError({ error: keluhan.error })"
          >
            {{ keluhan.message || '' }}
          </b-form-invalid-feedback>
        </b-col>
        <b-col cols="12" v-show="!isHiddenKeluhan">
          <div id="img_keluhan"></div>
        </b-col>
      </b-row>
    </b-col>

    <b-col cols="6" class="pr-0">
      <b-row>
        <b-col cols="12" class="row">
          <b-col cols="3" class="text-subtitle">
            <label>Anamnesa<span class="text-danger">*</span></label>
          </b-col>
          <b-col cols="9" class="float-right pen-isMobile">
            <div class="row d-flex justify-content-end mr-2">
              <div class="mt-2">
                <span @click="penColor('blue');isColorActive = 'blue'" class="dot grow" style="background-color: blue;"
                  :class="{ color_active: isColorActive === 'blue' }"></span>
                <span @click="penColor('red');isColorActive = 'red'" class="dot grow" style="background-color: red;"
                  :class="{ color_active: isColorActive === 'red' }"></span>
                <span @click="penColor('#54c756');isColorActive = 'green'" class="dot grow"
                  style="background-color: #54c756;" :class="{ color_active: isColorActive === 'green' }"></span>
                <span @click="penColor('#555');isColorActive = 'black'" class="dot grow" style="background-color: #555;"
                  :class="{ color_active: isColorActive === 'black' }"></span>
                <span @click="penColor('orange');isColorActive = 'yellow'" class="dot grow"
                  style="background-color: orange;" :class="{ color_active: isColorActive === 'yellow' }"></span>
              </div>
              <font-awesome-icon
                icon="eraser"
                class="font-size-xl m-2 grow icon"
                v-on:click="setDrawPostData('eraser');"
                v-show="!isHidden"
                :class="{ active_tool: isActive === 'eraser' }" />
              <font-awesome-icon
                icon="pen-alt"
                class="font-size-xl m-2 grow icon"
                v-on:click="setDrawPostData('pen');"
                :class="{ active_tool: isActive === 'pen' }" />
              <font-awesome-icon
                icon="keyboard"
                class="font-size-xl m-2 grow icon"
                v-on:click="setDrawPostData('keyboard');"
                  :class="{ active_tool: isActive === 'keyboard' }" />
            </div>
            <div class="row d-flex justify-content-end mr-2">
              <input type="range" class="custom-range pen-width" min="1" max="50" v-model.number="penWidth" />
            </div>
          </b-col>
        </b-col>
        <b-col cols="12" id="anamnesa_canvas" v-show="!isHidden">
          <canvas
            id="anamnesa-canvas"
            ref="canvas"
            @mousedown="handleMousedown"
            @mouseup="handleMouseup"
            @mousemove="handleMousemove"
            @touchstart="handleTouchstart"
            @touchend="handleTouchend"
            @touchmove="handleTouchmove"
            :width="canvasWidth"
            :height="canvasHeight"
          >
            Your browser does not support the HTML 5 Canvas.
          </canvas>
        </b-col>
        <b-col cols="2" v-show="!isHidden">
          <b-button @click="clear" variant="warning" size="sm" class="m-1">Clear</b-button>
        </b-col>

        <b-col cols="12" id="editor_anamnesa" v-show="isHidden">
          <Editor
            :height="contentHeight"
            :width="contentWidth"
            class="form-anamnesa"
            :editorContent="anamnesa"
            v-on:update-content="updateContent"
          />
          <b-form-invalid-feedback class="text-lowercase" :state="anamnesaValidationStatus">
            {{ anamnesaValidationMessage }}
          </b-form-invalid-feedback>
        </b-col>
        <b-col cols="12" v-show="!isHidden">
          <div id="img_anamnesa"></div>
        </b-col>
      </b-row>
    </b-col>
  </b-row>
</template>
  
<script>
  import { mapGetters, mapActions, mapState } from 'vuex';
  
  export default {
    name: 'SubjectiveAnamnesa',
    props: ['keluhanError'],
    components: {
      Editor: () => import('./Editor.vue')
    },
    data() {
      return {
        isDrawing: false,
        isHidden: true,
        isPen: false,
        isActive: 'keyboard',
        isColorActive: 'black',
        mousePos: { x: 0, y: 0 },
        lastPos: { x: 0, y: 0 },
        drawing: false,
        ctx: null,
        penWidth: 2,
        isDrawingKeluhan: false,
        isHiddenKeluhan: true,
        isPenKeluhan: false,
        isActiveKeluhan: 'keyboard',
        isColorActiveKeluhan: 'black',
        mousePosKeluhan: { x: 0, y: 0 },
        lastPosKeluhan: { x: 0, y: 0 },
        drawingKeluhan: false,
        ctxKeluhan: null,
        penWidthKeluhan: 2,
        ediRekamMedis: {},
        anamnesa: null,
        imgAnamnesa: null,
        imgKeluhan: null,
        keluhan: {
          value: null,
          error: false,
          message: null,
        },
        anamnesaValidationStatus: true,
        anamnesaValidationMessage: 'wajib diisi',
        contentWidth: 675,
        contentHeight: 155,
        canvasWidth: 675,
        canvasHeight: 180,
      };
    },
    computed: {
      ...mapState(['sidebar']),
      ...mapGetters('sidebar', ['collapsed', 'collapsedMobile', 'orientation']),
      ...mapGetters(['pasien', 'getKlinikId', 'trx', 'canvas_anamnesa', 'canvas_keluhan']),
      canvas() {
        return this.$refs.canvas;
      },
      canvaskeluhan() {
        return this.$refs.canvaskeluhan;
      },
    },
    watch: {
      imgAnamnesa() {
        this.imgAnamnesaChanged();
      },
      imgKeluhan() {
        this.imgKeluhanChanged();
      },
      pasien() {
        if (this.checkValueData(this.pasien)) {
          this.anamnesa = this.pasien.anamnesa || '';
          this.keluhan['value'] = this.pasien.keluhan || '';
        }
      },
      keluhanError() {
        this.keluhan.error = this.keluhanError;
        if (this.keluhan.error) this.keluhan.message = 'minimal 4 karakter, maksimal 255 karakter';
      },
      'keluhan.error'() {
        const editorKeluhan = document.getElementById('editor_keluhan');
        if (this.keluhan.error) {
          editorKeluhan.getElementsByClassName('ql-container')[0].style.setProperty('border', '1px solid red');
          editorKeluhan.getElementsByClassName('ql-container')[0].style.setProperty('border-top', '1px solid #ccc');
          editorKeluhan.getElementsByClassName('ql-toolbar')[0].style.setProperty('border', '1px solid red');
          editorKeluhan.getElementsByClassName('ql-toolbar')[0].style.setProperty('border-bottom', '1px solid #ccc');
        } else {
          editorKeluhan.getElementsByClassName('ql-container')[0].style.removeProperty('border');
          editorKeluhan.getElementsByClassName('ql-container')[0].style.removeProperty('border-top');
          editorKeluhan.getElementsByClassName('ql-toolbar')[0].style.removeProperty('border');
          editorKeluhan.getElementsByClassName('ql-toolbar')[0].style.removeProperty('border-bottom');
        }
      },
      anamnesaValidationStatus() {
        const editorAnamnesa = document.getElementById('editor_anamnesa');
        if (this.anamnesaValidationStatus) {
          editorAnamnesa.getElementsByClassName('ql-container')[0].style.removeProperty('border');
          editorAnamnesa.getElementsByClassName('ql-container')[0].style.removeProperty('border-top');
          editorAnamnesa.getElementsByClassName('ql-toolbar')[0].style.removeProperty('border');
          editorAnamnesa.getElementsByClassName('ql-toolbar')[0].style.removeProperty('border-bottom');
        } else {
          editorAnamnesa.getElementsByClassName('ql-container')[0].style.setProperty('border', '1px solid red');
          editorAnamnesa.getElementsByClassName('ql-container')[0].style.setProperty('border-top', '1px solid #ccc');
          editorAnamnesa.getElementsByClassName('ql-toolbar')[0].style.setProperty('border', '1px solid red');
          editorAnamnesa.getElementsByClassName('ql-toolbar')[0].style.setProperty('border-bottom', '1px solid #ccc');
        }
      },
      collapsed() {
        setTimeout(() => {
          this.resizeWidth(this.collapsed);
          this.imgAnamnesa = this.canvas_anamnesa ? this.canvas_anamnesa.toDataURL('image/png') : null;
          this.imgKeluhan = this.canvas_keluhan ? this.canvas_keluhan.toDataURL('image/png') : null;
        }, 500);
      },
      collapsedMobile() {
        setTimeout(() => {
          this.resizeWidth(this.collapsedMobile);
          this.imgAnamnesa = this.canvas_anamnesa ? this.canvas_anamnesa.toDataURL('image/png') : null;
          this.imgKeluhan = this.canvas_keluhan ? this.canvas_keluhan.toDataURL('image/png') : null;
        }, 500);
      },
      orientation() {
        setTimeout(() => {
          this.resizeWidth(this.collapsed);
          this.imgAnamnesa = this.canvas_anamnesa ? this.canvas_anamnesa.toDataURL('image/png') : null;
          this.imgKeluhan = this.canvas_keluhan ? this.canvas_keluhan.toDataURL('image/png') : null;
        }, 500);
      },
    },
    async mounted() {
      await this.resizeWidth(this.collapsed);
      
      this.ctx = this.canvas.getContext('2d');
      this.ctx.strokeStyle = '#222222';
      this.ctx.lineWidth = this.penWidth;
      this.ctx.lineJoin = 'round';
      this.ctx.lineCap = 'round';
      
      this.ctxKeluhan = this.canvaskeluhan.getContext('2d');
      this.ctxKeluhan.strokeStyle = '#222222';
      this.ctxKeluhan.lineWidth = this.penWidthKeluhan;
      this.ctxKeluhan.lineJoin = 'round';
      this.ctxKeluhan.lineCap = 'round';
  
      //append data canvas to vuex global state
      this.updateCanvas({ key: 'ANAMNESA', value: this.canvas });
      this.updatePostData({ key: 'anamnesa_is_draw', value: false });
  
      this.updateCanvas({ key: 'KELUHAN', value: this.canvaskeluhan });
      this.updatePostData({ key: 'keluhan_is_draw', value: false });
  
      this.ediRekamMedis = localStorage.getItem('edit_rekam_medis')
      if (this.ediRekamMedis != null) {
        this.setAnamnesaData(JSON.parse(this.ediRekamMedis))
      }
      // Get a regular interval for drawing to the screen
      window.requestAnimFrame = (function(callback) {
        return (
          window.requestAnimationFrame ||
          window.webkitRequestAnimationFrame ||
          window.mozRequestAnimationFrame ||
          window.oRequestAnimationFrame ||
          window.msRequestAnimaitonFrame ||
          function(callback) {
            window.setTimeout(callback, 1000 / 60);
          }
        );
      })();
  
      // Prevent scrolling when touching the canvas
      document.body.addEventListener(
        'touchstart',
        function(e) {
          if (e.target == document.getElementById('anamnesa-canvas')) {
            e.preventDefault();
          }
          if (e.target == document.getElementById('keluhan-canvas')) {
            e.preventDefault();
          }
        },
        false
      );
      document.body.addEventListener(
        'touchend',
        function(e) {
          if (e.target == document.getElementById('anamnesa-canvas')) {
            e.preventDefault();
          }
          if (e.target == document.getElementById('keluhan-canvas')) {
            e.preventDefault();
          }
        },
        false
      );
      document.body.addEventListener(
        'touchmove',
        function(e) {
          if (e.target == document.getElementById('anamnesa-canvas')) {
            e.preventDefault();
          }
          if (e.target == document.getElementById('keluhan-canvas')) {
            e.preventDefault();
          }
        },
        false
      );
  
      this.ediRekamMedis = localStorage.getItem('edit_rekam_medis')
      if (this.ediRekamMedis != null) this.setAnamnesaData(JSON.parse(this.ediRekamMedis));
    },
    methods: {
      ...mapActions(['updatePostData', 'updateCanvas', 'updatePasien']),
      resizeWidth(collapsed = false) {
        let elRM = document.getElementById('rekam_medis_klinik');

        let w = elRM.offsetWidth;
        let x = 1;

        if (w > 1400) x = 2.335;
        else if (collapsed) {
          if (this.orientation == 'portrait') x = 2.85;
          else {
            if (w < 1024) x = 2.9;
            else x = 2.55;
          }
        } else {
          if (this.orientation == 'portrait') x = 2.816;
          else {
            if (w < 750) x = 2.84;
            else if (w < 1024) x = 2.445;
            else x = 1.964;
          }
        }

        this.canvasWidth = this.contentWidth = w / x;
        this.canvasHeight = this.canvasWidth * 0.5625;
        this.contentHeight = this.canvasHeight * 0.9;
      },
      // called if user using wysiwyg instead of drawing canvas
      updateContent(content) {
        this.anamnesaValidationStatus = true;
        const kategori_id = this.checkValueData(this.trx) && this.trx.kategori_id;

        if (kategori_id == 2) {
          const strippedContent = content.replace(/<[^>]*>?/gm, '').trim();
    
          if (strippedContent.length == 0) {
            this.anamnesaValidationStatus = false;
            this.anamnesaValidationMessage = 'wajib diisi';
          }
          if (strippedContent.length < 10 || strippedContent.length > 255) {
            this.anamnesaValidationStatus = false;
            this.anamnesaValidationMessage = 'minimal 10 karakter, maksimal 255 karakter';
          }
        }
        
        this.updatePostData({ key: 'anamnesa_text', value: content });
        this.updatePasien({ data: {...this.pasien, anamnesa: content} });
      },
      updateContentKeluhan(content) {
        this.keluhan.error = false;
        this.keluhan.message = null;

        const kategori_id = this.checkValueData(this.trx) && this.trx.kategori_id;
        const strippedContent = content.replace(/<[^>]*>?/gm, '').trim();
        if (this.checkValueData(strippedContent) && (strippedContent.length < 4 || strippedContent.length > 255) && kategori_id == 2) {
          this.keluhan.error = true;
          this.keluhan.message = 'minimal 4 karakter, maksimal 255 karakter';
        }

        this.updatePostData({ key: 'keluhan', value: content });
        this.updatePasien({ data: {...this.pasien, keluhan: content} });
      },
      setAnamnesaData(d) {
        if (d.anamnesa && d.anamnesa.is_draw) {
          this.anamnesa = d.anamnesa.notes;
          if (d.anamnesa.draw_path != null) {
            this.imgAnamnesa = d.anamnesa.draw_path;
            this.updatePostData({ key: 'anamnesa_is_draw', value: true });
          }
        } else {
          this.anamnesa = d.anamnesa ? d.anamnesa.notes : null;
        }
        
        if (d.anamnesa && d.anamnesa.keluhan_is_draw) {
          this.keluhan.value = d.anamnesa.keluhan;
          if (d.anamnesa.keluhan_draw_path != null) {
            this.imgKeluhan = d.anamnesa.keluhan_draw_path;
            this.updatePostData({ key: 'keluhan_is_draw', value: true });
          }
        } else {
          this.keluhan.value = d.anamnesa ? d.anamnesa.keluhan : null;
        }
      },
      imgAnamnesaChanged() {
        let self = this;
        self.image_url = self.imgAnamnesa;
        self.clear();
        self.drawBackground(self.image_url);
      },
      imgKeluhanChanged() {
        let self = this;
        self.image_url = self.imgKeluhan;
        self.clearKeluhan();
        self.drawBackgroundKeluhan(self.image_url);
      },
      // draw the image
      drawBackground(image_url) {
        let self = this;
        let canvas = document.getElementById('anamnesa-canvas'),
          ctx = canvas.getContext('2d'),
          img_anamnesa = document.getElementById('img_anamnesa');
        let backgroundURL = image_url;
  
        let background = new Image();
        background.crossOrigin = 'Anonymous';
        background.src = backgroundURL;
  
        //remove existing image
        if (img_anamnesa.hasChildNodes()) {
          img_anamnesa.innerHTML = '';
        }
  
        background.onload = function() {
          let newSize = { width: self.canvasWidth, height: self.canvasHeight };
          ctx.drawImage(background, 0, 0, newSize.width, newSize.height);
        };
        this.isDrawing = true;
      },
      // draw the image
      drawBackgroundKeluhan(image_url) {
        let self = this;
        let canvas = document.getElementById('keluhan-canvas'),
          ctxKeluhan = canvas.getContext('2d'),
          img_keluhan = document.getElementById('img_keluhan');
        let backgroundURL = image_url;
  
        let background = new Image();
        background.crossOrigin = 'Anonymous';
        background.src = backgroundURL;
  
        //remove existing image
        if (img_keluhan.hasChildNodes()) {
          img_keluhan.innerHTML = '';
        }
  
        background.onload = function() {
          let newSize = { width: self.canvasWidth, height: self.canvasHeight };
          ctxKeluhan.drawImage(background, 0, 0, newSize.width, newSize.height);
        };
        this.isDrawingKeluhan = true;
      },
      handleMousedown(e) {
        this.lastPos = this.getMousePos(e);
        this.ctx.lineWidth = this.penWidth;
        this.drawing = true;
      },
      handleMousedownKeluhan(e) {
        this.lastPosKeluhan = this.getMousePosKeluhan(e);
        this.ctxKeluhan.lineWidth = this.penWidthKeluhan;
        this.drawingKeluhan = true;
      },
      handleMouseup(e) {
        this.drawing = false;
      },
      handleMouseupKeluhan(e) {
        this.drawingKeluhan = false;
      },
      handleMousemove(e) {
        this.mousePos = this.getMousePos(e);
        if (this.drawing) {
          this.ctx.beginPath();
          // pen drawing
          if (this.isPen) {
            this.ctx.globalCompositeOperation = 'source-over';
            this.ctx.moveTo(this.lastPos.x, this.lastPos.y);
            this.ctx.lineTo(this.mousePos.x, this.mousePos.y);
            this.ctx.stroke();
          } else {
            // eraser
            this.ctx.globalCompositeOperation = 'destination-out';
            this.ctx.arc(
              this.mousePos.x,
              this.mousePos.y,
              this.penWidth,
              0,
              Math.PI * 2,
              false
            );
            this.ctx.fill();
          }
          this.lastPos = this.mousePos;
        }
      },
      handleMousemoveKeluhan(e) {
        this.mousePosKeluhan = this.getMousePosKeluhan(e);
        if (this.drawingKeluhan) {
          this.ctxKeluhan.beginPath();
          // pen drawing
          if (this.isPenKeluhan) {
            this.ctxKeluhan.globalCompositeOperation = 'source-over';
            this.ctxKeluhan.moveTo(this.lastPosKeluhan.x, this.lastPosKeluhan.y);
            this.ctxKeluhan.lineTo(this.mousePosKeluhan.x, this.mousePosKeluhan.y);
            this.ctxKeluhan.stroke();
          } else {
            // eraser
            this.ctxKeluhan.globalCompositeOperation = 'destination-out';
            this.ctxKeluhan.arc(
              this.mousePosKeluhan.x,
              this.mousePosKeluhan.y,
              this.penWidthKeluhan,
              0,
              Math.PI * 2,
              false
            );
            this.ctxKeluhan.fill();
          }
          this.lastPosKeluhan = this.mousePosKeluhan;
        }
      },
      handleTouchstart(event) {
        this.mousePos = this.getTouchPos(event);
        let touch = event.touches[0];
        let mouseEvent = new MouseEvent('mousedown', {
          clientX: touch.clientX,
          clientY: touch.clientY
        });
        this.canvas.dispatchEvent(mouseEvent);
      },
      handleTouchstartKeluhan(event) {
        this.mousePosKeluhan = this.getTouchPosKeluhan(event);
        let touch = event.touches[0];
        let mouseEvent = new MouseEvent('mousedown', {
          clientX: touch.clientX,
          clientY: touch.clientY
        });
        this.canvaskeluhan.dispatchEvent(mouseEvent);
      },
      handleTouchend(event) {
        let mouseEvent = new MouseEvent('mouseup', {});
        this.canvas.dispatchEvent(mouseEvent);
      },
      handleTouchendKeluhan(event) {
        let mouseEvent = new MouseEvent('mouseup', {});
        this.canvaskeluhan.dispatchEvent(mouseEvent);
      },
      handleTouchmove(event) {
        let touch = event.touches[0];
        let mouseEvent = new MouseEvent('mousemove', {
          clientX: touch.clientX,
          clientY: touch.clientY
        });
        this.canvas.dispatchEvent(mouseEvent);
      },
      handleTouchmoveKeluhan(event) {
        let touch = event.touches[0];
        let mouseEvent = new MouseEvent('mousemove', {
          clientX: touch.clientX,
          clientY: touch.clientY
        });
        this.canvaskeluhan.dispatchEvent(mouseEvent);
      },
      getMousePos(mouseEvent) {
        const rect = this.canvas.getBoundingClientRect();
        return {
          x: mouseEvent.clientX - rect.left,
          y: mouseEvent.clientY - rect.top
        };
      },
      getMousePosKeluhan(mouseEvent) {
        const rect = this.canvaskeluhan.getBoundingClientRect();
        return {
          x: mouseEvent.clientX - rect.left,
          y: mouseEvent.clientY - rect.top
        };
      },
      // Get the position of a touch relative to the canvas
      getTouchPos(touchEvent) {
        const rect = this.canvas.getBoundingClientRect();
        return {
          x: touchEvent.touches[0].clientX - rect.left,
          y: touchEvent.touches[0].clientY - rect.top
        };
      },
      getTouchPosKeluhan(touchEvent) {
        const rect = this.canvaskeluhan.getBoundingClientRect();
        return {
          x: touchEvent.touches[0].clientX - rect.left,
          y: touchEvent.touches[0].clientY - rect.top
        };
      },
      // to change pen color
      penColor(color) {
        this.ispen = true;
        this.ctx.strokeStyle = color;
      },
      penColorKeluhan(color) {
        this.isPenKeluhan = true;
        this.ctxKeluhan.strokeStyle = color;
      },
      // to clear the canvas
      clear() {
        this.canvas.width = this.canvas.width;
        this.isDrawing = false;
        this.isColorActive = 'black';
      },
      clearKeluhan() {
        this.canvaskeluhan.width = this.canvaskeluhan.width;
        this.isDrawingKeluhan = false;
        this.isColorActiveKeluhan = 'black';
      },
      setDrawPostData(type) {
        if (type == 'pen') {
          this.isPen = true;
          this.isHidden = false;
          this.isDrawing = true;
        } else if (type == 'eraser') {
          this.isPen = false;
          this.isHidden = false;
        } else {
          this.isPen = false;
          this.isHidden = true;
        }
        this.isActive = type;
        this.updatePostData({ key: 'anamnesa_is_draw', value: this.isDrawing });
      },
      setDrawPostDataKeluhan(type) {
        if (type == 'pen') {
          this.isPenKeluhan = true;
          this.isHiddenKeluhan = false;
          this.isDrawingKeluhan = true;
        } else if (type == 'eraser') {
          this.isPenKeluhan = false;
          this.isHiddenKeluhan = false;
        } else {
          this.isPenKeluhan = false;
          this.isHiddenKeluhan = true;
        }
        this.isActiveKeluhan = type;
        this.updatePostData({ key: 'keluhan_is_draw', value: this.isDrawingKeluhan });
      },
    },
  };
</script>
  
<style scoped>
  #anamnesa-canvas {
    touch-action: none;
  }
  #keluhan-canvas {
    touch-action: none;
  }
  .mb-10 {
    margin-bottom: 10rem !important;
  }
</style>

<style>
  .form-keluhan .quill-editor .ql-container.ql-snow .ql-editor.ql-blank::before {
    content: 'Tuliskan keluhan utama secara singkat, contoh: Sakit kepala, demam, dll' !important;
  }
  .pen-width {
    width: 125px !important;
  }
  #editor_keluhan .form-keluhan .quill-editor .ql-toolbar {
    border-top-right-radius: 5px;
    border-top-left-radius: 5px;
  }
  #editor_keluhan .form-keluhan .quill-editor .ql-container {
    border-bottom-right-radius: 5px;
    border-bottom-left-radius: 5px;
  }
  .form-anamnesa .quill-editor .ql-container.ql-snow .ql-editor.ql-blank::before {
    content: 'Tuliskan detail keluhan, contoh: demam 3 hari' !important;
  }
  #editor_anamnesa .form-anamnesa .quill-editor .ql-toolbar {
    border-top-right-radius: 5px;
    border-top-left-radius: 5px;
  }
  #editor_anamnesa .form-anamnesa .quill-editor .ql-container {
    border-bottom-right-radius: 5px;
    border-bottom-left-radius: 5px;
  }
  .form-anamnesa .quill-editor .ql-toolbar {
    zoom: 75%;
  }
  .form-anamnesa .quill-editor .ql-container {
    color: #505050;
    font-size: 14px;
  }
  .form-keluhan .quill-editor .ql-toolbar {
    zoom: 75%;
  }
  .form-keluhan .quill-editor .ql-container {
    color: #505050;
    font-size: 14px;
  }
  @media screen and (max-width: 1400px) {
    .form-anamnesa .quill-editor .ql-toolbar {
      zoom: 70%;
    }
    .form-anamnesa .quill-editor .ql-container {
      color: #505050;
      font-size: 12px;
    }
    .form-keluhan .quill-editor .ql-toolbar {
      zoom: 70%;
    }
    .form-keluhan .quill-editor .ql-container {
      color: #505050;
      font-size: 12px;
    }
  }
  @media screen and (max-width: 1024px) {
    .form-anamnesa .quill-editor .ql-toolbar {
      zoom: 60%;
    }
    .form-anamnesa .quill-editor .ql-container {
      color: #505050;
      font-size: 10px;
    }
    .form-keluhan .quill-editor .ql-toolbar {
      zoom: 60%;
    }
    .form-keluhan .quill-editor .ql-container {
      color: #505050;
      font-size: 10px;
    }
  }
</style>